export const LONG_FORM_MEDIA_DURATION_SECONDS = 15 * 60;

export const EDITOR_PLAYBACK_PRIORITY_EVENT = "vb:editor-playback-priority";
export const EDITOR_LONG_VIDEO_MEDIA_CLOCK_EVENT = "vb:editor-long-video-media-clock";

export type EditorLongVideoMediaClockDetail = {
  active: boolean;
  playheadSec: number;
  sampledAtMs: number;
  playheadRate: number;
  elementId: string | null;
};

export function isLongFormMediaDuration(durationSec: number | null | undefined): boolean {
  return typeof durationSec === "number" && Number.isFinite(durationSec) && durationSec >= LONG_FORM_MEDIA_DURATION_SECONDS;
}

export function looksLikeProxyPlaybackUrl(url: string | null | undefined): boolean {
  if (typeof url !== "string" || url.trim() === "") return false;
  const normalized = url.toLowerCase();
  return (
    normalized.includes(".m3u8") ||
    normalized.includes("/proxy.") ||
    normalized.includes(".proxy.") ||
    normalized.includes("/hls/") ||
    normalized.includes("/studiomedia/")
  );
}

export function resolveEditorPreviewSource(previewUrl: string | null | undefined, src: string | null | undefined): string {
  if (typeof previewUrl === "string" && previewUrl.trim() !== "") return previewUrl;
  return typeof src === "string" ? src : "";
}

export function shouldDeferLongVideoBackgroundWork(args: {
  durationSec: number | null | undefined;
  previewUrl?: string | null;
  srcUrl?: string | null;
}): boolean {
  const { durationSec, previewUrl, srcUrl } = args;
  if (!isLongFormMediaDuration(durationSec)) return false;
  return !looksLikeProxyPlaybackUrl(resolveEditorPreviewSource(previewUrl, srcUrl));
}

export function shouldProtectLongVideoPreview(args: {
  durationSec: number | null | undefined;
  previewUrl?: string | null;
  srcUrl?: string | null;
  deferVideoHydration?: boolean;
}): boolean {
  if (args.deferVideoHydration === true) return true;
  return shouldDeferLongVideoBackgroundWork(args);
}

export function shouldProtectLongVideoPlayback(args: {
  durationSec: number | null | undefined;
  previewUrl?: string | null;
  srcUrl?: string | null;
  deferVideoHydration?: boolean;
  isPlaying?: boolean;
}): boolean {
  if (args.isPlaying !== true) return false;
  return shouldProtectLongVideoPreview(args);
}
